'use strict';

/* jshint esversion: 6 */
/* jshint -W051 */
(function ($) {
	$(document).ready(function () {
		// Hero Carousel
		var loopStatus, dragStatus, heroSlides;
		heroSlides = $('.hero .slide').length;

		if (heroSlides === 1) {
			loopStatus = false;
			dragStatus = false;
		} else {
			loopStatus = true;
			dragStatus = true;
		}

		var heroCarousel = $('.hero .owl-carousel');
		var heroNext = $('.owl-next');
		var heroPrev = $('.hero-nav .prev');

		heroCarousel.owlCarousel({
			items: 1,
			autoPlay: false,
			loop: loopStatus,
			dots: true,
			nav: true,
			// dotsContainer: '.hero-dots',
			draggable: dragStatus,
			mouseDrag: dragStatus,
			touchDrag: dragStatus,

			onInitialized: function onInitialized() {
				if ($(".owl-item.active video", this.$element).length) {
					$(".owl-item.active video", this.$element)[0].play();
					heroCarousel.trigger('stop.owl.autoplay');
				}
				$('.hero .owl-carousel .owl-nav button').removeAttr('role');
			}
		});

		heroNext.on('click', function () {
			heroCarousel.trigger('next.owl.carousel');
			return false;
		});

		// heroNext.nextSibling('span').empty();

		heroPrev.on('click', function () {
			heroCarousel.trigger('prev.owl.carousel');
			return false;
		});

		$('.owl-prev').attr('title', 'Previous');
		$('.owl-next').attr('title', 'Next');
		$('.owl-dot[role="button"]:nth-child(1)').attr('title', 'First item');
		$('.owl-dot[role="button"]:nth-child(2)').attr('title', 'Second item');
		$('.owl-dot[role="button"]:nth-child(3)').attr('title', 'Third item');
		$('.owl-dot[role="button"]:nth-child(4)').attr('title', 'Fourth item');

		function singlePlay() {
			var heroVideo = document.querySelector('.owl-item.active video');

			// check for the loop attribute, which is set via the hero slide paragraph
			if (heroVideo && !heroVideo.hasAttribute('loop')) {
				heroVideo.addEventListener('ended', function () {
					// this assumes that the video to only play once is the first slide, and the slide to jump to follows it in the sequence.
					// was using next.owl.carousel, but that was buggy and would send you to the last slide if you were going through
					// the carousel a second (or subsequent) time.
					heroCarousel.trigger('to.owl.carousel', 1);
				}, true);
			}

			// when the slide changes, check to see if there's a video in it, and if there is, start it playing, while disabling owl's autoplay.
			// then run singlePlay again to see if it's another single loop video. If the slide doesn't contain a video, we carry on as normal.
			heroCarousel.on('changed.owl.carousel', function (e) {
				setTimeout(function () {
					if (document.querySelector('.owl-item.active video')) {
						var _heroVideo = document.querySelector('.owl-item.active video');
						_heroVideo.play();
						heroCarousel.trigger('stop.owl.autoplay');
					}
					singlePlay();
				}, 1);
			});
		}

		singlePlay();
	});
})(jQuery);